import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment-timezone'
import RequestReviewButtons from '../Reviews/RequestReviewButtons'
import ReviewResponse from '../Reviews/ReviewResponse'
import css from './styles.css'

const ScheduleBoxRow = ({
  appointment,
  patient,
  doctor,
  review,
  location,
  requestReview,
  pmsType,
}) => {
  const showRequestReviewButton = !!requestReview
  const showReviewResponse = !requestReview && !!review
  const showPatientLink = !process.env.REACT_APP_IS_TOPS
  return (
    <li className={css.bodyRow}>
      <span className={css.date}>
        {moment(appointment.appointment_datetime).format('MMMM Do')}
      </span>
      <span className={css.time}>
        {moment(appointment.appointment_datetime).format('h:mm a')}
      </span>
      <span className={css.patient}>
        {showPatientLink ? (
          <Link to={`/patients/${patient.id}`}>
            {`${patient.first_name} ${patient.last_name}`}
          </Link>
        ) : (
          <span>{`${patient.first_name} ${patient.last_name}`}</span>
        )}
      </span>
      {pmsType !== 'OrthoTrac' && (
        <span className={css.doctor}>
          {doctor.preferred_name}
        </span>
      )}
      {!showReviewResponse && (
        <span className={css.status}>
          {appointment.status}
        </span>
      )}
      {!showReviewResponse && (
        <span className={css.confirmed}>
          {appointment.confirmed ? 'confirmed' : 'unconfirmed'}
        </span>
      )}
      {showReviewResponse && (
        <span className={css.location}>
          {location.name}
        </span>
      )}
      {showReviewResponse && (
        <span className={css.review}>
          <ReviewResponse review={review} />
        </span>
      )}
      {showRequestReviewButton && (
        <RequestReviewButtons
          small
          appointment={appointment}
          requestReview={requestReview}
        />
      )}
    </li>
  )
}

ScheduleBoxRow.propTypes = {
  appointment: PropTypes.shape({
    appointment_datetime: PropTypes.string,
    confirmed: PropTypes.bool,
    status: PropTypes.string,
  }).isRequired,
  patient: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  doctor: PropTypes.shape({
    preferred_name: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    name: PropTypes.string,
  }),
  review: PropTypes.shape({
    positive: PropTypes.bool,
    stars: PropTypes.number,
  }),
  requestReview: PropTypes.func,
}

ScheduleBoxRow.defaultProps = {
  appointment: { appointment_datetime: '', confirmed: false },
  patient: { first_name: '', last_name: '' },
  doctor: { preferred_name: '' },
  pmsType: PropTypes.string,
}

export default ScheduleBoxRow



// WEBPACK FOOTER //
// ./src/components/sitewide/ScheduleBox/Row.js